import type { ZoomUnaryIncrement } from "./ZoomContext.ts";

export const MODULE_MAP_PERSPECTIVE_ID = "module-map-perspective";

export const ZOOM_STEPS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.5, 3, 4, 5];

export const MIN_ZOOM = ZOOM_STEPS[0];
export const MAX_ZOOM = ZOOM_STEPS[ZOOM_STEPS.length - 1];

export const WHEEL_ZOOM_STEP = 0.1;

// Gestures land between steps, so step from the current zoom rather than from its position in the steps.
export const getSteppedZoom = (delta: ZoomUnaryIncrement, currentZoom: number): number =>
  delta === 1
    ? (ZOOM_STEPS.find((step) => step > currentZoom) ?? MAX_ZOOM)
    : (ZOOM_STEPS.findLast((step) => step < currentZoom) ?? MIN_ZOOM);
